import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

// import AuthRoute from '../components/auth-route';
// import UnauthRoute from '../components/unauth-route';
import Tenant from '../sub-projects/tenant/main';
import IntegrationsRoutes from './integrations';
import ReportsRoutes from './reports';

class TenantRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <Route exact={true} path='/console/tenants/:tenantid' component={Tenant} />
          <Route path='/console/tenants/:tenantid/integrations' component={IntegrationsRoutes} />
          <Route path='/console/tenants/:tenantid/reports' component={ReportsRoutes} />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default connect(
  mapStateToProps
)(TenantRoutes);




// WEBPACK FOOTER //
// ./src/routes/tenant.tsx